import { useRef, useEffect, DependencyList, EffectCallback } from 'react';

const useDebouncedEffect = (
  effect: EffectCallback,
  delay: number,
  deps: DependencyList,
) => {
  const timeoutHandle = useRef<ReturnType<typeof setTimeout>>();
  const cleanup = useRef<ReturnType<EffectCallback> | null>(null);

  useEffect(() => {
    timeoutHandle.current = setTimeout(() => {
      cleanup.current = effect();
    }, delay);

    return () => {
      if (timeoutHandle.current != null) {
        clearTimeout(timeoutHandle.current);
      }

      if (typeof cleanup.current === 'function') {
        cleanup.current();
      }
    };
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [effect, delay, ...deps]);
};

export default useDebouncedEffect;
